<template>
    <button class="flex flex-row h-full w-full" @click='onClick'>
      <div class="mx-4 w-full self-center">
        <div class="grow overflow-hidden justify-center items-center flex" style='background-color: #313131'>
          <div style='background-color: #313131'>
            <img :src='imageUrl'
                  class="object-contain w-full h-64" />
          </div>
          <play-circle class="text-black" :size='128' />
        </div>

      </div>
    </button>
</template>
<script>
import PlayCircle from '@icons/PlayCircle.vue';
export default {
  inject:['api'],
  props:{
    video: {
      type: Object,
      required: true
    }
  },
  components:{
    PlayCircle
  },
  computed: {
    imageUrl() {
      return this.api.makeThumbnailUrlEditor(this.video.thumbnail);
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
}
</script>

